(function () {
  if (customElements.get('mout-quantity-stepper')) return;

  class MoutQuantityStepper extends HTMLElement {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.addButton = this.querySelector('.mout-quantity-stepper__add-button');
      this.controls = this.querySelector('.mout-quantity-stepper__controls');
      this.countEl = this.querySelector('.mout-quantity-stepper__count');
      this.decrementButton = this.querySelector('.mout-quantity-stepper__decrement');
      this.incrementButton = this.querySelector('.mout-quantity-stepper__increment');
      this.busy = false;

      if (!this.addButton || !this.controls || !this.countEl || !this.decrementButton || !this.incrementButton) {
        console.error('mout-quantity-stepper: missing expected child element(s)', {
          addButton: this.addButton,
          controls: this.controls,
          countEl: this.countEl,
          decrementButton: this.decrementButton,
          incrementButton: this.incrementButton,
        });
        return;
      }

      this.addButton.addEventListener('click', this.handleAdd.bind(this));
      this.incrementButton.addEventListener('click', this.handleIncrement.bind(this));
      this.decrementButton.addEventListener('click', this.handleDecrement.bind(this));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
      }

      this.syncWithCart();
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    handleCartUpdate(event) {
      if (this.busy) return;
      if (!event || !event.cartData || !event.cartData.items) return;
      var item = event.cartData.items.find(function (i) {
        return String(i.variant_id) === String(this.variantId);
      }, this);
      if (item) {
        this.showControls(item.quantity);
      } else {
        this.showAddButton();
      }
    }

    handleVariantChange(event) {
      if (!event || !event.data || !event.data.variant) return;
      this.variantId = String(event.data.variant.id);
      this.dataset.variantId = this.variantId;
      var available = event.data.variant.available;
      this.dataset.available = available;
      this.addButton.disabled = !available;
      this.addButton.textContent = available
        ? this.addButton.getAttribute('data-add-label')
        : this.addButton.getAttribute('data-sold-out-label');
      this.syncWithCart();
    }

    syncWithCart() {
      var self = this;
      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var item = cart.items.find(function (i) {
            return String(i.variant_id) === String(self.variantId);
          });
          if (item) {
            self.showControls(item.quantity);
          } else {
            self.showAddButton();
          }
        })
        .catch(function (err) { console.error('mout-quantity-stepper:', err); });
    }

    showAddButton() {
      this.addButton.hidden = false;
      this.controls.hidden = true;
    }

    showControls(quantity) {
      this.addButton.hidden = true;
      this.controls.hidden = false;
      this.countEl.textContent = quantity;
    }

    setBusy(state) {
      this.busy = state;
      this.addButton.disabled = state || this.dataset.available === 'false';
      this.incrementButton.disabled = state;
      this.decrementButton.disabled = state;
    }

    setCartDrawerEmptyState(isEmpty) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.classList.toggle('is-empty', !!isEmpty);
    }

    setCheckoutButtonEnabled(isEnabled) {
      var checkoutButton = document.getElementById('CartDrawer-Checkout');
      if (!checkoutButton) return;
      checkoutButton.disabled = !isEnabled;
    }

    refreshCartIconBubble(sections) {
      if (!sections || !sections['cart-icon-bubble']) return;
      var target = document.getElementById('cart-icon-bubble');
      if (!target) return;
      var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newContent = parsed.querySelector('.shopify-section');
      if (newContent) target.innerHTML = newContent.innerHTML;
    }

    refreshFreeShippingBar(sections) {
      if (!sections || !sections['cart-drawer']) return;
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var freshBar = parsed.querySelector('.mout-free-shipping-bar');
      var currentBar = document.querySelector('.mout-free-shipping-bar');
      if (freshBar && currentBar) {
        currentBar.replaceWith(freshBar);
      } else if (freshBar && !currentBar) {
        var form = document.getElementById('CartDrawer-Form');
        if (form) form.insertAdjacentElement('afterend', freshBar);
      } else if (!freshBar && currentBar) {
        currentBar.remove();
      }
    }

    publishCartUpdate(cartData) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mout-quantity-stepper',
          productVariantId: Number(this.variantId),
          cartData: cartData,
        });
      }
    }

    handleAdd() {
      if (this.busy) return;
      var variantId = this.variantId;
      if (!variantId || isNaN(Number(variantId))) {
        console.error('mout-quantity-stepper: invalid variantId', variantId, this);
        return;
      }
      this.setBusy(true);
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: 'cart-icon-bubble,cart-drawer' }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status) {
            console.error('mout-quantity-stepper: add to cart failed', JSON.stringify(data), 'sent id=' + variantId);
            return;
          }
          self.showControls(1);
          self.setCartDrawerEmptyState(false);
          self.setCheckoutButtonEnabled(true);
          self.refreshCartIconBubble(data.sections);
          self.refreshFreeShippingBar(data.sections);
          self.publishCartUpdate(data);
        })
        .catch(function (err) { console.error('mout-quantity-stepper:', err); })
        .finally(function () {
          self.setBusy(false);
        });
    }

    handleIncrement() {
      if (this.busy) return;
      var variantId = this.variantId;
      if (!variantId || isNaN(Number(variantId))) {
        console.error('mout-quantity-stepper: invalid variantId', variantId, this);
        return;
      }
      this.setBusy(true);
      var self = this;
      var addSections;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: 'cart-icon-bubble,cart-drawer' }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (addData) {
          if (addData.status) {
            console.error('mout-quantity-stepper: increment failed', JSON.stringify(addData), 'sent id=' + variantId);
            return Promise.reject(addData);
          }
          addSections = addData.sections;
          return fetch('/cart.js').then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          var item = cart.items.find(function (i) {
            return String(i.variant_id) === String(variantId);
          });
          var qty = item ? item.quantity : 1;
          self.showControls(qty);
          self.setCartDrawerEmptyState(false);
          self.setCheckoutButtonEnabled(true);
          self.refreshCartIconBubble(addSections);
          self.refreshFreeShippingBar(addSections);
          self.publishCartUpdate(cart);
        })
        .catch(function (err) { console.error('mout-quantity-stepper:', err); })
        .finally(function () {
          self.setBusy(false);
        });
    }

    handleDecrement() {
      if (this.busy) return;
      var variantId = this.variantId;
      if (!variantId || isNaN(Number(variantId))) {
        console.error('mout-quantity-stepper: invalid variantId', variantId, this);
        return;
      }
      this.setBusy(true);
      var self = this;
      var currentQty = parseInt(this.countEl.textContent, 10) || 1;
      var newQty = currentQty - 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: newQty, sections: 'cart-icon-bubble,cart-drawer' }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (cart.status) {
            console.error('mout-quantity-stepper: cart change failed', JSON.stringify(cart), 'sent id=' + variantId + ' quantity=' + newQty);
            self.syncWithCart();
            return;
          }
          if (newQty <= 0) {
            self.showAddButton();
          } else {
            self.showControls(newQty);
          }
          self.setCartDrawerEmptyState(cart.item_count === 0);
          self.setCheckoutButtonEnabled(cart.item_count > 0);
          self.refreshCartIconBubble(cart.sections);
          self.refreshFreeShippingBar(cart.sections);
          self.publishCartUpdate(cart);
        })
        .catch(function (err) { console.error('mout-quantity-stepper:', err); })
        .finally(function () {
          self.setBusy(false);
        });
    }
  }

  customElements.define('mout-quantity-stepper', MoutQuantityStepper);
})();
